<template>
    <div
        class="d-flex"
        :class="{
            'justify-content-center': centered
        }"
    >
        <template v-if="prefix && value && computedField">
            {{ prefix }}
        </template>
        {{ computedField || '-' }}
        <template v-if="suffix && value && computedField">
            {{ suffix }}
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            centered: {
                type: Boolean,
                default: false
            },
            suffix: {
                type: String,
                required: false,
                default: null
            },
            prefix: {
                type: String,
                required: false,
                default: null
            },
            type: {
                required: false,
                type: String,
                default: 'text'
            },
            value: {
                type: [String, Number],
                required: false,
                default: null
            },
            fieldOption: {
                type: Object,
                required: false,
                default: null
            },
            defaultValue: {
                type: [String, Number],
                required: false,
                default: null
            },
            filter: {
                type: [RegExp, String],
                required: false,
                default: ''
            }
        },
        computed: {
            computedField() {
                const baseValue = this.value && this.filter
                    ? this.value.replace(this.filter, '')
                    : this.value || this.defaultValue
                switch (this.type) {
                    case 'text':
                        return baseValue
                    case 'date':
                        if (!baseValue) return ''

                        const dateFormat = this.fieldOption?.dateFormat || 'YYYY-MM-DD' // Fallback
                        const parsedDate = Date.parse(baseValue)
                        return isNaN(parsedDate) ? baseValue : this.$d(parsedDate, dateFormat)
                    default:
                        return baseValue
                }
            }
        }
    }
</script>
